import { API_UNAUTHORIZED, API_FORBIDDEN } from 'app/middleware/constants';
import { LOAD_PROJECTS, LOAD_PROJECT, CREATE_PROJECT } from 'app/store/projects/types.js';
import { LIST_USER_DETAILS, ACCEPT_TERMS } from 'app/store/users/types.js';
import { WEBSOCKET_ERROR } from 'app/store/websocketStatus/types';
import { GET_VIEW } from 'app/store/view/types.js';
import { LOAD_COLUMN_STATISTICS } from 'app/store/columnStatistics/types';
import { DELETE_ATTRIBUTE_DEFINITION, SET_ATTRIBUTE_VALUE } from 'app/store/attributes/types';
import { ADD_USERS_TO_SPACE, DELETE_USERS_FROM_SPACE, GET_TAGS } from 'app/store/types.js';
import { UPDATE_PROJECT_OWNER } from 'app/store/entities/types';
import {
    CREATE_CATEGORY,
    CREATE_GLOSSARY_TERM,
    DELETE_CATEGORY,
    DELETE_GLOSSARY_TERM,
    LOAD_GLOSSARY,
    RENAME_CATEGORY,
    UPDATE_GLOSSARY_TERM
} from 'app/store/glossary/types.js';
import { SEARCH_PROJECTS } from 'app/store/search/types';
import { extractError } from 'app/lib/error';
import { CLEAR_ERROR, FOREIGN_HTTP_ERROR } from './types';

export const INITIAL_STATE = null;

function storeError(action) {
    const code = action.payload?.code;
    const error = extractError(action.payload);
    return {
        ...error,
        code
    };
}

export function errorReducer(state = INITIAL_STATE, action) {
    // Should handle all failures that aren't handled/displayed locally in a component or a snack bar
    switch (action.type) {
        // general errors
        case API_FORBIDDEN:
        case API_UNAUTHORIZED:
        case WEBSOCKET_ERROR:
            return storeError(action);

        // initial loads
        case LOAD_GLOSSARY.FAILED:
        case LOAD_PROJECTS.FAILED:
        case LOAD_PROJECTS.REJECTED:
        case SEARCH_PROJECTS.FAILED:
            return storeError(action);

        // page loads
        case GET_VIEW.FAILED:
        case GET_VIEW.REJECTED:
        case LOAD_PROJECT.FAILED:
        case LOAD_PROJECT.REJECTED:
            return storeError(action);

        // commands with no visible component
        case ACCEPT_TERMS.FAILED:
        case CREATE_PROJECT.REJECTED:
        case CREATE_PROJECT.FAILED:
            return storeError(action);

        // operations that could display an error locally but do not (yet)
        case ADD_USERS_TO_SPACE.FAILED:
        case DELETE_USERS_FROM_SPACE.FAILED:
        case DELETE_ATTRIBUTE_DEFINITION.FAILED:
        case DELETE_CATEGORY.FAILED:
        case DELETE_GLOSSARY_TERM.FAILED:
        case GET_TAGS.FAILED:
        case LIST_USER_DETAILS.FAILED:
        case UPDATE_PROJECT_OWNER.FAILED:
        case LOAD_COLUMN_STATISTICS.FAILED:
        case CREATE_CATEGORY:
        case CREATE_GLOSSARY_TERM.FAILED:
        case UPDATE_GLOSSARY_TERM.FAILED:
        case RENAME_CATEGORY.FAILED:
        case SET_ATTRIBUTE_VALUE.FAILED:
            return storeError(action);

        case FOREIGN_HTTP_ERROR:
            return storeError(action);

        case CLEAR_ERROR:
            return null;

        default:
            return state;
    }
}
